module.exports = require("http");


//////////////////
// WEBPACK FOOTER
// external "http"
// module id = 12
// module chunks = 0